import {
  ADD_TO_CART,
  UPDATE_CART_QUANTITY,
  REMOVE_FROM_CART,
  ADD_MULTIPLE_TO_CART,
  UPDATE_CATEGORIES,
  UPDATE_CURRENT_CATEGORY,
  CLEAR_CART,
  TOGGLE_CART,
  UPDATE_CART_LINES_INSTOCK,
  SET_USER,
  LOGGED_IN_USER,
  SIGNUP_MODAL_FLAG,
  SIGNUP_MODAL_DISMISSED
} from "./actions";

export const reducer = (state, action) => {
  switch (action.type) {

    case ADD_TO_CART:
      return {
        ...state,
        cartOpen: true,
        cart: [...state.cart, action.product],
      };

    case ADD_MULTIPLE_TO_CART:
      return {
        ...state,
        cart: [...state.cart, ...action.products],
      };

    case UPDATE_CART_QUANTITY:
      return {
        ...state,
        cartOpen: true,
        cart: state.cart.map(product => {
          if (action._id === product._id) {
            return {
              ...product,
              purchaseQuantity: action.purchaseQuantity
            };
          } else {
            return product;
          }
        })
      };

    case UPDATE_CART_LINES_INSTOCK:
      return {
        ...state,
        cart: state.cart.map(product =>
          ({
            ...product,
            inStock: Boolean(action.products.find(p => p._id === product._id))
          }))
      };

    case REMOVE_FROM_CART:
      let newState = state.cart.filter(product => {
        return product._id !== action._id;
      });

      return {
        ...state,
        cartOpen: newState.length > 0,
        cart: newState
      };

    case CLEAR_CART:
      return {
        ...state,
        cartOpen: false,
        cart: []
      };

    case TOGGLE_CART:
      return {
        ...state,
        cartOpen: !state.cartOpen
      };

    case UPDATE_CATEGORIES:
      return {
        ...state,
        categories: [...action.categories],
      };

    case UPDATE_CURRENT_CATEGORY:
      return {
        ...state,
        currentCategory: action.currentCategory
      };

    // This is used to store the verified user record each time Nav validates it.
    case SET_USER:
      return { ...state, currentUser: action.user };

    // This sets the user record at login time only.
    // It's used to signal logged-in status has changed, e.g. to refresh Nav.
    case LOGGED_IN_USER:
      return { ...state, loggedInUser: action.user };

    case SIGNUP_MODAL_FLAG:
      return { ...state, signupModalOpen: action.show };

    case SIGNUP_MODAL_DISMISSED:
      return { ...state, signupModalDismissed: action.dismissed };

    default:
      return state;
  }
};

export default reducer;